<template>
  <div
    class="overflow-hidden bg-white cursor-pointer flex flex-col"
    @click="goToChallengeDetail()"
  >
    <div class="relative">
      <img
        :src="imageSrc"
        alt=""
        class="w-full sm:w-[405px] h-[228px] object-cover rounded-lg"
      />
      <div
        v-if="gridType !== 'history'"
        class="absolute top-2 left-2 bg-white rounded-full p-2"
      >
        <span
          v-if="
            activityType ===
              ActivityType.CUSTOM_CHALLENGE_ACTIVITY_TYPE_BICYCLE ||
            compType === ActivityType.COMPETITIVE_CHALLENGE_TYPE_BICYCLE
          "
          ><BikeIcon />
        </span>
        <span
          v-else-if="
            activityType ===
              ActivityType.CUSTOM_CHALLENGE_ACTIVITY_TYPE_STEPS ||
            compType === ActivityType.COMPETITIVE_CHALLENGE_TYPE_STEPS
          "
          ><WalkIcon />
        </span>
        <span v-else><MoreDotIcon /></span>
      </div>
    </div>
    <div class="py-4 flex justify-between items-start">
      <div>
        <div class="text-sm font-semibold">
          <span v-if="category === ChallengeType.CUSTOM_CHALLENGE">{{
            $t("label.custom.challenge")
          }}</span>
          <span v-else-if="category === ChallengeType.COMPETITIVE_CHALLENGE">
            {{ $t("label.competitive.challenge") }}
          </span>
        </div>
        <div class="text-lg line-clamp-2">
          {{ title }}
        </div>
      </div>
      <div v-if="gridType === 'active'" class="pr-4">
        <IconButton class="bg-bkk-50 rounded-full p-2">
          <PencilIcon />
        </IconButton>
      </div>
      <div v-if="gridType === 'history'" class="pr-4">
        <IconButton class="bg-bkk-50 rounded-full p-2">
          <ArrowRight />
        </IconButton>
      </div>
    </div>
    <div class="h-full flex flex-col justify-between">
      <div class="grid grid-cols-12">
        <div class="col-span-1 content-center"><StartDateIcon /></div>
        <div class="col-span-11">
          {{ dayjs(startDate).format("DD.MM.YYYY") }}
        </div>
        <div class="col-span-1 content-center"><IntervalIcon /></div>
        <div class="capitalize col-span-11">
          {{ $t("challenge.preview.daily") }}
        </div>
        <div class="col-span-1 content-center"><EndDateIcon /></div>
        <div class="col-span-11">{{ dayjs(endDate).format("DD.MM.YYYY") }}</div>
      </div>
      <ButtonWithIcon
        v-if="gridType === 'all'"
        active
        :label="$t('challenge.preview.start.cta.label')"
        :icon="StartChallengeIcon"
        class="w-full mt-4"
        icon-position="right"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChallengeType } from "../../../enum/v2/challengeType.ts";
import { ActivityType } from "../../../enum/v2/activityType.ts";
import IconButton from "../layout/IconButton.vue";
import PencilIcon from "../../v2/icon/PencilIcon.vue";
import BikeIcon from "../icon/BikeIcon.vue";
import WalkIcon from "../icon/WalkIcon.vue";
import MoreDotIcon from "../icon/MoreDotIcon.vue";
import StartDateIcon from "../icon/StartDateIcon.vue";
import IntervalIcon from "../icon/IntervalIcon.vue";
import EndDateIcon from "../icon/EndDateIcon.vue";
import dayjs from "dayjs";
import ButtonWithIcon from "../layout/button/ButtonWithIcon.vue";
import StartChallengeIcon from "../icon/StartChallengeIcon.vue";
import { useRouter } from "vue-router";
import defaultImage from "../../../assets/images/default.jpg";
import ArrowRight from "../icon/ArrowRight.vue";

const props = defineProps<{
  id: string;
  image: string;
  title: string;
  category: string;
  activityType: string;
  compType?: string;
  startDate?: string;
  endDate?: string;
  gridType: string;
}>();

const router = useRouter();
const imageSrc = computed(() => props.image || defaultImage);

function goToChallengeDetail() {
  if (props.category === ChallengeType.CUSTOM_CHALLENGE) {
    router.push({
      name: "customChallengeDetail",
      params: {
        challengeId: props.id,
      },
      state: { fromHistory: true },
    });
  } else if (props.category === ChallengeType.COMPETITIVE_CHALLENGE) {
    router.push({
      name: "competitiveChallengeDetail",
      params: {
        challengeId: props.id,
      },
      state: { fromHistory: true },
    });
  }
}
</script>
